import { Select, SelectItem, SelectProps } from '@mantine/core';
import { useMemo } from 'react';

type DeviceFaultPropertySelectProps = Omit<SelectProps, 'data'>;

/**
 * Select for device fault properties.
 */
export default function DeviceFaultPropertySelect(props: DeviceFaultPropertySelectProps) {
  const properties: SelectItem[] = useMemo(
    () =>
      [
        { value: 'externalId', label: 'Externé ID' },
        { value: 'deviceId', label: 'ID Zariadenia' },
        { value: 'faultName', label: 'Názov' },
        { value: 'description', label: 'Popis' },
        { value: 'moreInfo', label: 'Dodatok' },
        { value: 'faultSeverityId', label: 'Závažnosť' },
      ] satisfies SelectItem[],
    []
  );

  return <Select data={properties} {...props} />;
}
